import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/skills/$skillId')({

}).lazy(() => import('./$skillId.lazy').then((d) => d.Route));
